<script lang="ts" setup>
withDefaults(defineProps<{ color?: string }>(), {
  color: "black",
});
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="74"
    height="74"
    viewBox="0 0 74 74"
    fill="none"
  >
    <g filter="url(#filter0_d_2502_17266)">
      <circle cx="37" cy="33" r="25.5" :stroke="color" />
    </g>
    <path
      d="M42.865 27.135C42.685 26.955 42.3934 26.955 42.2134 27.135L37 32.3484L31.7866 27.135C31.6066 26.955 31.315 26.955 31.135 27.135C30.955 27.315 30.955 27.6066 31.135 27.7866L36.3484 33L31.135 38.2134C30.955 38.3934 30.955 38.685 31.135 38.865C31.315 39.045 31.6066 39.045 31.7866 38.865L37 33.6516L42.2134 38.865C42.3934 39.045 42.685 39.045 42.865 38.865C43.045 38.685 43.045 38.3934 42.865 38.2134L37.6516 33L42.865 27.7866C43.045 27.6066 43.045 27.315 42.865 27.135Z"
      :fill="color"
    />
    <defs>
      <filter
        id="filter0_d_2502_17266"
        x="0"
        y="0"
        width="74"
        height="74"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="5.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.113725 0 0 0 0 0.121569 0 0 0 0 0.133333 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2502_17266"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2502_17266"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
</template>
